import { useState, useCallback } from 'react';

interface UseFormFieldsDisableResult<T> {
  isDisabled: Partial<Record<keyof T, boolean>>;
  setFieldDisabled: (fieldName: keyof T, disabled: boolean) => void;
  setFieldsDisabled: (fields: Partial<Record<keyof T, boolean>>) => void;
  resetDisabledFields: () => void;
}

export function useFormFieldsDisable<T = any>(initialDisabledFields: Partial<Record<keyof T, boolean>> = {}): UseFormFieldsDisableResult<T> {
  const [isDisabled, setIsDisabled] = useState<Partial<Record<keyof T, boolean>>>(initialDisabledFields);

  const setFieldDisabled = useCallback((fieldName: keyof T, disabled: boolean = true) => {
    setIsDisabled(prev => ({
      ...prev,
      [fieldName]: disabled
    }));
  }, []);

  const setFieldsDisabled = useCallback((fields: Partial<Record<keyof T, boolean>>) => {
    setIsDisabled(prev => ({
      ...prev,
      ...fields
    }));
  }, []);

  const resetDisabledFields = useCallback(() => {
    setIsDisabled({});
  }, []);

  return {
    isDisabled,
    setFieldDisabled,
    setFieldsDisabled,
    resetDisabledFields
  };
}
